import { render, staticRenderFns } from "./VehicleLabel.vue?vue&type=template&id=52912208&scoped=true&"
import script from "./VehicleLabel.vue?vue&type=script&lang=js&"
export * from "./VehicleLabel.vue?vue&type=script&lang=js&"
import style0 from "./VehicleLabel.vue?vue&type=style&index=0&id=52912208&scoped=true&lang=scss&"
import style1 from "./VehicleLabel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52912208",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
